export default "__VITE_ASSET__CAFTOk2o__"